export const WIDGET_CONTACT_FORM_TYPE = 'contact';
